const translations = {
    cancel: 'Cancel',
    createMapButton: 'Create map',
    errorAreaTooLarge: 'Total flight area is too large to process.',
    errorMaxFlights: 'A flight group can have at most {max} flights for map generation.',
    errorMixedFlightTypes: 'All flights in the group must be the same type.',
    errorNoMapTypes: 'No map types are available for this flight group.',
    errorNoSprayData: 'Flights must have spray data to generate this map.',
    errorRequest: 'Failed to start map generation. Try again.',
    mapTypeAam: 'As Applied Map (gal/min)',
    mapTypeAamSprayByArea: 'As Applied Map (gal/acre)',
    mapTypeAsFlown: 'As Flown Map',
    mapTypeCoverage: 'Coverage Map',
    mapTypeDryCoverage: 'Dry Coverage Map',
    mapTypeLabel: 'Map type',
    mapTypePlaceholder: 'Select a map type',
    processing: 'Processing…',
    title: 'Create map'
};

export default translations;
